import React from 'react';
import PropTypes from 'prop-types';

import * as Icons from '../icons/Icons';
import SvgLoading from '../SvgLoading';

import { COPY } from './utils/UploadManager';
import { UPLOAD_MANAGER_SHAPE } from './shapes';

export default class PromoteGalleryToHero extends React.PureComponent {
    static propTypes = {
        mediaId: PropTypes.string.isRequired,
        uploadManager: UPLOAD_MANAGER_SHAPE.isRequired,
        toggleWarningAboutPromoting: PropTypes.func.isRequired,
        onHeroPromotion: PropTypes.func.isRequired
    }

    state = {
        isSaving: false,
        error: ''
    };

    promoteToHero = () => {
        const { mediaId, onHeroPromotion, uploadManager } = this.props;

        this.setState({
            isSaving: true,
            error: ''
        });

        const onError = (err) => {
            // eslint-disable-next-line no-console
            console.log(err);
            this.setState({
                error: 'The server had trouble creating the hero image. Please try again.',
                isSaving: false
            });
        };

        const onCompletion = (res) => {
            if (res && !res.data.err) {
                // Timeout to prevent 403 errors
                setTimeout(() => {
                    this.setState({
                        isSaving: false,
                        error: ''
                    }, () => {
                        // close the modal
                        this.props.toggleWarningAboutPromoting();

                        // Scroll to top of page so user can see their new hero
                        const heroTitle = document.getElementById("hero-image-heading");
                        heroTitle.scrollIntoView(false);

                        // Envoke callback
                        onHeroPromotion();
                    });
                }, 2000);
            }
            else {
                onError(res.data.err);
            }
        }

        const image = {
            media_id: mediaId,
            is_primary: true
        };

        const task = {
            type: COPY,
            image,
            onCompletion,
            onError
        };

        // Save data to the server
        uploadManager.addTask(task);
    }

    render() {
        const { toggleWarningAboutPromoting } = this.props;
        const { isSaving, error } = this.state;

        return (
            <div>
                <h2>This May Result in a Low Quality Hero Image</h2>
                <div className="rec-photo-help-modal-content">
                    <div className="rec-photo-help-modal-left-col">
                        <img
                            src="img/sample-low-res-photo.jpg"
                            alt="illustration of low resolution hero"
                            className="rec-photo-help-modal-tilted" />
                    </div>
                    <div className="rec-photo-help-modal-right-col">
                        <p>
                            Using an existing gallery image can result in a low
                            quality, stretched, or blurred hero image, as most
                            gallery photos do not meet hero image specifications.
                            Promoting a gallery image as your hero image should
                            only be used as a temporary solution until a higher
                            quality hero image can be uploaded.
                        </p>
                        <p>
                            After promoting a gallery image, you may need to
                            adjust the cropping for the new image. If the image
                            is not large enough, the cropping tool will not allow
                            you to make the adjustments needed to use the photo
                            as the hero image for your location.
                        </p>
                    </div>

                </div>

                <div className="rec-photo-help-modal-buttons">
                    <button
                        className="rec-button-tertiary-alt-small"
                        onClick={toggleWarningAboutPromoting}>
                        Cancel
                    </button>
                    <button className="rec-button-primary-small" onClick={this.promoteToHero}>
                        Promote to Hero Image Anyway
                    </button>
                </div>

                {isSaving && (
                    <div className="rec-photo-help-modal-status rec-photo-help-modal-loading">
                        <SvgLoading size="small" /> Creating New Hero Image ...
                    </div>
                )}
                {error && error.length > 0 && (
                    <div className="rec-photo-help-modal-status rec-photo-help-modal-error">
                        <Icons.IconError /> {error}
                    </div>
                )}
            </div>
        );
    }
}
